import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateCofig} from "./column";
import moment from "moment";

import {framework_tool,component_tool} from '../../../tool';
import createExportColumns from "./exportColumns";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizBrowserExport,WizModal} = component_tool;

const _getValue = (type, key) => {
  const values = {
    status: {
      0: '待审核',
      1: '已通过',
      2: '审核中',
      3: '未通过',
      4: '已取消报名'
    },
    enrollWay: {
      0: '协调员报名',
      1: '学员报名',
      2: '管理报名',
    },
    planType: {
      0: '通用',
      1: '班级',
      // 2: '活动',
    },
    auditType: {
      0: '自动审核',
      1: '人工审核'
    },
    infoType:{
      0:'无',
      1:'文字信息',
      2:'问卷收集'
    },
    personState:{ //disable
      0:'激活',
      1:'未激活'
    },
    jobState:{
      0:'离职',
      1:'在职'
    }
  }
  return values[type][key]
}

/**获取表格的内容*/
function getTableData(data) {
  let dataInfo = []
  if (data && data.length) {
    dataInfo = data
    dataInfo.forEach(e => {
      if (e['disabled'] === 0) {
        e['disabled'] = "激活"
      } else {
        e['disabled'] = "禁用"
      }
      if (e['userType'] === 0) {
        e['userType'] = "学员"
      } else if (e['userType'] === 1) {
        e['userType'] = "SGM总部"
      } else if (e['userType'] === 2) {
        e['userType'] = "SGM区域"
      } else if (e['userType'] === 3) {
        e['userType'] = "供应商"
      } else {
        e['userType'] = ""
      }
      if (e['questions'] && e['questions'].length) {
        e['questions'].forEach(q => {
          let answerOptions = []
          let title = new Set();
          if (q['answerOptions'] && q['answerOptions'].length) {
            answerOptions = q['answerOptions']
            answerOptions.forEach(a => {
              if (a['content']) {
                title.add(a['content'])
              }
            })
          } else {
            if (q['answer']) {
              title.add(q['answer'])
            }
          }
          if (q['otherAnswer'] && q['otherAnswer'].length) {
            title.add(q['otherAnswer'])
          }
          e[q['title']] = Array.from(title).toString();
        })
      }
    })
  }
  return dataInfo;
}

class Apply extends WizContainer {
  componentName = 'apply'

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  /**获取导出数据*/
  _surveyAnswerExportOver(nextProps, nextState,key) {
    if (nextProps.surveyAnswerList.code === 1) {
      let data = nextProps.surveyAnswerList.data
      let columnDefs = createExportColumns(this, data, null)
      let dataInfo = getTableData(data)
      WizBrowserExport({
        title: '问卷记录信息',
        sheetName: '问卷记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: '问卷记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success("修改状态成功")
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleDelCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '编号',
        field: 'id',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账户',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'email',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账户状态',
        field: 'personState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '区域',
        field: 'areaName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '计划安排',
        field: 'planName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '计划安排开始时间',
        field: 'planStartTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '计划安排结束时间',
        field: 'planEndTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '提交报名时间',
        field: 'applySubmitTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '报名状态',
        field: 'status',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人账户',
        field: 'applicantUserName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人姓名',
        field: 'applicantFullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人手机',
        field: 'applicantMobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '申请人邮箱',
        field: 'applicantEmail',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let record=data['record']
      record.forEach((val, index) => {
          val['personState'] =  _getValue('personState', val['personState'])
          val['status'] =  _getValue('status', val['status'])
          val['jobState'] =  _getValue('jobState', val['jobState'])
      })
      let apply = data['apply']
      let name=apply['name']
      let startTime=apply['startTime']
      let endTime=apply['endTime']
      let enrollWay=apply['enrollWay']
      let planType=apply['planType']
      let str = '报名名称：'+name+'\n'
        +'报名时间：'+moment(startTime).format("YYYY-MM-DD")+'~'+moment(endTime).format("YYYY-MM-DD")+'\n'+
        '报名方式：'+_getValue('enrollWay',enrollWay)+'\n'+
        '报名安排类型：'+_getValue('planType',planType)+'\n'
      WizBrowserExport({
        title: str,
        sheetName: '导出报名记录',
        columns: columnDefs.filter((_, index) => index),
        rows: record,
        filename: '报名信息.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 60
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig({
      _planManagement: (e) => {
        let {planType} = e.record
        if (planType && planType === 1) {
          this.jumpPage('push', '/workflow/apply/applyPlanClass', { ...e.record });
        } else {
          this.jumpPage('push', '/workflow/apply/applyPlanNormal', { ...e.record });
        }
      }
    })
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        enable:(nextProps, nextState, key) =>{
          let o = nextProps[key]
          if (o['success']) {
            
            let bizId = o['data']
            if(bizId){
              if(bizId>0){
              WizModal.confirm({
                title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
                onOk: () => {
                  this.doAction({
                    path:  "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: bizId,
                        bizType: 15,
                        resend:true
                      },
                    },
                  })
                },
                onCancel: () => {
                  this.doActions([
                    {
                      path:  "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizId,
                          bizType: 15,
                          resend:false
                        },
                      },
                    },
                  ]);
                }
              });
            }else{
              
              this.doActions([
                {
                  path:  "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: 0-bizId,
                      bizType: 15,
                      resend:false
                    },
                  },
                },
              ]);
            }
            }
            wizNotice.success("修改状态成功")
            return true;
          } else {
            wizNotice.error(o['msg'])
            return false;
          }
        },
        delete: this._handleDelCMD,
        export: this._handleFile,
        surveyAnswerList: this._surveyAnswerExportOver,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(Apply)
